import { render, staticRenderFns } from "./newKeyWordStatisticsDetail.vue?vue&type=template&id=7800c8f9&scoped=true&"
import script from "./newKeyWordStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./newKeyWordStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newKeyWordStatisticsDetail.vue?vue&type=style&index=0&id=7800c8f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7800c8f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7800c8f9')) {
      api.createRecord('7800c8f9', component.options)
    } else {
      api.reload('7800c8f9', component.options)
    }
    module.hot.accept("./newKeyWordStatisticsDetail.vue?vue&type=template&id=7800c8f9&scoped=true&", function () {
      api.rerender('7800c8f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/newKeyWordStatisticsDetail.vue"
export default component.exports